module.exports = {
    dynamo_tables: {
      beta_waiting_list: 'beta_waiting_list',
    },
    aws_remote_config: {
      accessKeyId: 'AKIAWO2H37WZWUHNDBHM',
      secretAccessKey: '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',
      region: 'us-east-2',
    }
};